import { getStore } from '../store';

export default (): string => getStore().DateFormat;
